var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_1076_13246)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coins"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.2852 46C35.7116 46 45.7852 35.7025 45.7852 23C45.7852 10.2975 35.7116 0 23.2852 0C10.8588 0 0.785156 10.2975 0.785156 23C0.785156 35.7025 10.8588 46 23.2852 46Z",
    fill: "url(#paint0_linear_1076_13246)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.3,
    d: "M23.2852 45.3082C10.9712 45.3082 0.971203 35.1977 0.789807 22.6553C0.789807 22.7694 0.785156 22.8859 0.785156 23C0.785156 35.7017 10.8596 46 23.2852 46C35.7107 46 45.7852 35.7017 45.7852 23C45.7852 22.8835 45.7828 22.7694 45.7805 22.6553C45.5991 35.1977 35.5991 45.3106 23.2852 45.3106V45.3082Z",
    fill: "#FDF356"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M23.2852 0.865323C35.5712 0.865323 45.5549 10.9306 45.7805 23.4327C45.7828 23.2876 45.7852 23.145 45.7852 23C45.7852 10.2983 35.7107 0 23.2852 0C10.8596 0 0.785156 10.2983 0.785156 23C0.785156 23.145 0.787482 23.2876 0.789807 23.4327C1.01539 10.9306 10.9991 0.865323 23.2852 0.865323Z",
    fill: "#FDF356"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    style: {
      mixBlendMode: "screen"
    },
    d: "M23.2851 45.893C35.6537 45.893 45.6805 35.6434 45.6805 23C45.6805 10.3565 35.6537 0.106934 23.2851 0.106934C10.9165 0.106934 0.889771 10.3565 0.889771 23C0.889771 35.6434 10.9165 45.893 23.2851 45.893Z",
    fill: "url(#paint1_radial_1076_13246)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.7,
    d: "M23.2851 0.0854492C11.1154 0.0854492 1.2107 10.0058 0.889771 22.3675C3.36651 23.8676 7.26186 22.6671 9.80838 21.3643C11.9991 20.3302 14.6944 20.6749 17.0526 20.8484C22.9479 21.3643 28.6758 23.9484 34.5712 22.3984C35.7502 22.0537 37.434 20.5037 38.613 21.5379C40.6898 23.3065 43.4805 23.4611 45.6805 22.3842C45.3665 10.0153 35.4595 0.0854492 23.2851 0.0854492Z",
    fill: "url(#paint2_linear_1076_13246)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M23.2852 40.8126C32.9091 40.8126 40.7108 32.8376 40.7108 22.9998C40.7108 13.1621 32.9091 5.18701 23.2852 5.18701C13.6613 5.18701 5.85962 13.1621 5.85962 22.9998C5.85962 32.8376 13.6613 40.8126 23.2852 40.8126Z",
    fill: "url(#paint3_linear_1076_13246)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M23.2851 39.9477C32.4415 39.9477 39.8642 32.3601 39.8642 23.0002C39.8642 13.6404 32.4415 6.05273 23.2851 6.05273C14.1288 6.05273 6.70605 13.6404 6.70605 23.0002C6.70605 32.3601 14.1288 39.9477 23.2851 39.9477Z",
    fill: "#EE9B00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M23.2851 39.2556C32.0677 39.2556 39.1875 31.9776 39.1875 22.9999C39.1875 14.0221 32.0677 6.74414 23.2851 6.74414C14.5025 6.74414 7.38281 14.0221 7.38281 22.9999C7.38281 31.9776 14.5025 39.2556 23.2851 39.2556Z",
    fill: "url(#paint4_radial_1076_13246)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    opacity: 0.25,
    d: "M23.2851 38.0457C14.6433 38.0457 7.61304 31.3466 7.38746 22.5674C7.38281 22.71 7.38281 22.855 7.38281 23C7.38281 31.979 14.5014 39.2558 23.2851 39.2558C32.0689 39.2558 39.1875 31.979 39.1875 23C39.1875 22.855 39.1875 22.7124 39.1828 22.5674C38.9596 31.3442 31.927 38.0457 23.2851 38.0457Z",
    fill: "#FDF356"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    opacity: 0.1,
    d: "M33.2293 20.7607C33.0619 20.2353 32.627 19.8597 32.0921 19.7812L26.8805 19.0062L24.5503 14.178C24.3107 13.6836 23.827 13.3745 23.2875 13.3745C22.7479 13.3745 22.2642 13.6812 22.0247 14.178L19.6945 19.0062L14.4828 19.7812C13.9479 19.8597 13.5131 20.2353 13.3456 20.7607C13.1782 21.286 13.3154 21.8518 13.7014 22.2369L17.4735 25.9954L16.5828 31.3014C16.4921 31.8458 16.7061 32.3855 17.1433 32.7088C17.5712 33.0273 18.1572 33.0701 18.627 32.8181L23.2898 30.3125L27.9526 32.8181C28.1619 32.9299 28.3852 32.9845 28.6107 32.9845C28.9014 32.9845 29.1898 32.8918 29.4363 32.7088C29.8735 32.3855 30.0875 31.8435 29.9968 31.3014L29.1061 25.9954L32.8782 22.2369C33.2642 21.8518 33.4014 21.286 33.234 20.7607H33.2293Z",
    fill: "#FDF356"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    d: "M32.9061 20.6939C32.7782 20.2945 32.4479 20.0092 32.0409 19.9498L26.6526 19.1487L24.2433 14.1588C24.0619 13.7832 23.6944 13.5479 23.2828 13.5479C22.8712 13.5479 22.5037 13.7808 22.3223 14.1588L19.913 19.1487L14.5247 19.9498C14.1177 20.0092 13.7875 20.2945 13.6596 20.6939C13.5316 21.0933 13.6363 21.5236 13.9293 21.816L17.4898 25.5269L16.5689 31.0136C16.4991 31.4272 16.6596 31.9027 16.9921 32.1499C17.1805 32.2902 17.7526 32.6111 18.4596 32.3401L23.2782 29.7489L28.0968 32.3377C28.4596 32.5327 29.0642 32.5374 29.3968 32.2902C29.7293 32.0429 30.0596 31.4249 29.9898 31.0112L29.0689 25.5245L32.6293 21.8136C32.9223 21.5212 33.027 21.0909 32.8991 20.6915L32.9061 20.6939Z",
    fill: "url(#paint5_linear_1076_13246)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_12",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9061 19.6578C32.7782 19.2584 32.4479 18.9731 32.0409 18.9137L26.6526 18.1125L24.2433 13.1227C24.0619 12.7471 23.6944 12.5117 23.2828 12.5117C22.8712 12.5117 22.5037 12.7447 22.3223 13.1227L19.913 18.1125L14.5247 18.9137C14.1177 18.9731 13.7875 19.2584 13.6596 19.6578C13.5316 20.0571 13.6363 20.4874 13.9293 20.7798L17.8293 24.6643L16.9084 30.151C16.8386 30.5646 17.0014 30.9735 17.334 31.2208C17.5223 31.361 17.7409 31.43 17.9619 31.43C18.1316 31.43 18.3037 31.3872 18.4619 31.304L23.2805 28.7128L28.0991 31.3016C28.4619 31.4965 28.8944 31.4656 29.227 31.2184C29.5596 30.9712 29.7223 30.5623 29.6526 30.1486L28.7316 24.6619L32.6316 20.7775C32.9247 20.4851 33.0293 20.0548 32.9014 19.6554L32.9061 19.6578Z",
    fill: "#EE9B00"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M24.0177 13.5811L26.4874 18.6946L32.0084 19.5147C32.6781 19.6146 32.9456 20.4561 32.4619 20.9387L28.4665 24.9182L29.4084 30.5381C29.5223 31.2204 28.8223 31.741 28.2246 31.4177L23.2874 28.7646L18.3502 31.4177C17.7502 31.7386 17.0502 31.2204 17.1665 30.5381L18.1084 24.9182L14.113 20.9387C13.6293 20.4561 13.8967 19.6146 14.5665 19.5147L20.0874 18.6946L22.5572 13.5811C22.8572 12.9606 23.7223 12.9606 24.0223 13.5811H24.0177Z",
    fill: "url(#paint6_linear_1076_13246)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    opacity: 0.3,
    d: "M18.0317 25.3633L17.1643 30.5386C17.141 30.6741 17.1526 30.8048 17.1875 30.9213L18.1084 25.437L18.034 25.3633H18.0317Z",
    fill: "#FDF356"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M14.5642 20.0334L20.4224 19.2132L22.8922 14.0997C23.1922 13.4793 23.3805 13.4793 23.6805 14.0997L26.1503 19.2132L32.0084 20.0334C32.3433 20.0833 32.5759 20.3187 32.6666 20.5992C32.8154 20.1356 32.5387 19.5912 32.0084 19.5128L26.4875 18.6926L24.0177 13.5791C23.7177 12.9587 22.8526 12.9587 22.5526 13.5791L20.0829 18.6926L14.5619 19.5128C14.0317 19.5912 13.7549 20.1356 13.9038 20.5992C13.9945 20.3163 14.227 20.0809 14.5619 20.0334H14.5642Z",
    fill: "#FDF356"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    opacity: 0.3,
    d: "M28.5387 25.3633L28.4642 25.437L29.3852 30.9213C29.42 30.8025 29.4317 30.6741 29.4084 30.5386L28.541 25.3633H28.5387Z",
    fill: "#FDF356"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    style: {
      mixBlendMode: "screen"
    },
    d: "M24.0177 13.5811L26.4874 18.6946L32.0084 19.5147C32.6781 19.6146 32.9456 20.4561 32.4619 20.9387L28.4665 24.9182L29.4084 30.5381C29.5223 31.2204 28.8223 31.741 28.2246 31.4177L23.2874 28.7646L18.3502 31.4177C17.7502 31.7386 17.0502 31.2204 17.1665 30.5381L18.1084 24.9182L14.113 20.9387C13.6293 20.4561 13.8967 19.6146 14.5665 19.5147L20.0874 18.6946L22.5572 13.5811C22.8572 12.9606 23.7223 12.9606 24.0223 13.5811H24.0177Z",
    fill: "url(#paint7_radial_1076_13246)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    style: {
      mixBlendMode: "screen"
    },
    d: "M32.0061 19.5147L26.4852 18.6946L24.0154 13.5811C23.7154 12.9606 22.8503 12.9606 22.5503 13.5811L20.0805 18.6946L14.5596 19.5147C14.2759 19.5575 14.0643 19.7334 13.9526 19.9569C14.6526 20.8507 14.9201 21.0076 16.0619 21.8302C19.5573 23.8485 28.2992 23.5014 30.7247 21.4855C31.6271 20.7342 31.9503 20.6344 32.4968 19.7881C32.3759 19.6478 32.2085 19.5456 32.0015 19.5147H32.0061Z",
    fill: "url(#paint8_linear_1076_13246)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1076_13246",
    x1: 23.2852,
    y1: 0,
    x2: 23.2852,
    y2: 46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8DF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FCE800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFEF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3A700"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1076_13246",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0595 -3.16418) scale(17.9186 18.3168)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF77D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1076_13246",
    x1: 23.2851,
    y1: 42.1701,
    x2: 23.2851,
    y2: 8.79336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1076_13246",
    x1: 23.2852,
    y1: 40.8126,
    x2: 23.2852,
    y2: -2.95511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FCD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F7B900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5AE00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1076_13246",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.4549 8.99303) scale(31.9744 32.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#FFDF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3A700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1076_13246",
    x1: 23.2851,
    y1: 32.4827,
    x2: 23.2851,
    y2: 13.5479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE9B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#F2B500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1076_13246",
    x1: 23.2851,
    y1: 13.1151,
    x2: 23.2851,
    y2: 45.2462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FAC800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7CF00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1076_13246",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.1153 9.31626) scale(15.9023 16.2557)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1076_13246",
    x1: 23.2294,
    y1: 31.3202,
    x2: 23.2294,
    y2: 19.8927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1076_13246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 46,
    fill: "white",
    transform: "translate(0.785156)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.9d1c91100afbcad043de6c7da5151b57.svg";
export { ForwardRef as ReactComponent };